import { formatOrderMoney as formatMoneyForOrder, getActiveCurrency } from './currencyFormat';
import { formatSelectedOptionsLabel } from './productVariants';

export const formatOrderItemVariantLabel = (item) =>
    formatSelectedOptionsLabel(
        item?.selectedOptions,
        item?.selectedSize || item?.size,
        item?.selectedColor || item?.color
    );

/** Orders store the currency they were placed in, so that wins over the store's current one. */
export const formatOrderMoney = (amount, currency) => {
    const value = Number(amount) || 0;
    const { code, symbol, locale } = getActiveCurrency();
    return formatMoneyForOrder(value, currency, code, { fallbackSymbol: symbol, locale });
};

export const resolveOrderItemName = (name, lang) => {
    if (name && typeof name === 'object') {
        return name[lang] || name.en || Object.values(name)[0] || '';
    }
    return String(name || '');
};

export const getProductOrderStatusClass = (status) => {
    switch (status?.toLowerCase()) {
        case 'pending':
            return 'status-pending';
        case 'confirmed':
            return 'status-confirmed';
        case 'processing':
            return 'status-preparing';
        case 'shipped':
            return 'status-ready';
        case 'delivered':
            return 'status-delivered';
        case 'completed':
            return 'status-completed';
        case 'cancelled':
            return 'status-cancelled';
        case 'refunded':
            return 'status-cancelled';
        default:
            return 'status-pending';
    }
};

export const getProductOrderStatusStep = (status) => {
    const normalized = status?.toLowerCase();
    const steps = ['pending', 'confirmed', 'processing', 'shipped', 'delivered'];
    const index = steps.indexOf(normalized);
    if (normalized === 'completed') return 5;
    if (normalized === 'cancelled' || normalized === 'refunded') return 0;
    return index >= 0 ? index + 1 : 1;
};

export const canCancelProductOrder = (orderStatus) =>
    ['pending', 'confirmed'].includes(orderStatus?.toLowerCase());
